import { ErrorMessage } from '@hookform/error-message';
import styles from 'Components/Auth/TextInput/TextInput.module.css';
import ErrorMessageStyle from 'Components/Form/ErrorMessageStyle';
import Label from 'Components/Form/Label';
import { RegisterOptions } from 'react-hook-form';
export interface TextInputProps extends ITextField {
  labelIcon?: React.ReactNode;
  rules?: RegisterOptions;
  disabled?: boolean;
  register?: any;
  label?: string;
  errors?: any;
  maxLength?: number;
}
export const TextInputBasic = ({
  name,
  type,
  placeholder = 'Enter...',
  rules,
  label,
  labelIcon,
  disabled,
  register,
  maxLength,
  errors,
}: TextInputProps) => {
  const props = { ...register(name, rules) };

  return (
    <>
      <Label label={label} labelIcon={labelIcon}>
        <input
          {...register(name, rules)}
          className={'form__input'}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
        />
        {errors && (
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <ErrorMessageStyle message={message} />}
          />
        )}
      </Label>
    </>
  );
};
